module.exports = __webpack_public_path__ + "static/media/dressW.a503b5ad.jpg";